import type { ScheduleDraftScheduleItem } from "@btnet/services-btnet/handlers/models/scheduleDraftScheduleItem";
import type { ScheduleDraftState } from "@btnet/services-btnet/handlers/models/scheduleDraftState";
import type { ScheduleHistoryItem } from "@btnet/services-btnet/handlers/models/scheduleHistoryItem";

export enum DraftOperations {
    Discard = "discard",
    Refresh = "refresh",
    EnableDraftMode = "enableDraftMode",
    DisableDraftMode = "disableDraftMode",
}

export interface IDraftHistoryState {
    current: IScheduleDraftRevisionState;
    history: IScheduleDraftRevisionState[];
    future: IScheduleDraftRevisionState[];
    originalSnapshot?: ScheduleDraftScheduleItem[];
}

export interface IDraftHistoryStore {
    [key: string]: IDraftHistoryState;
}

export interface IScheduleDraftRevisionState extends ScheduleDraftState {
    delta?: ICombinedHistoryItem;
}

export interface ICombinedHistoryItem extends ScheduleHistoryItem {
    isDraft?: boolean;
}
